import React from 'react'
import { CarouselSvg, TextSvg, RichCardSvg } from '../../../../components/Icons'
import { TEXT_TYPE, CAROUSEL_TYPE, CARD_TYPE, ALL_BUTTONS_TYPES } from './constants'
import { XMarkIcon } from '@heroicons/react/24/outline'

const COLOR_GREY_BLUE = '#29275c'
const getSvg = (type, isButton) => {
  if (isButton) {
    for (const buttonType of ALL_BUTTONS_TYPES) {
      if (buttonType.type === type) {
        const Icon = buttonType.icon
        return <Icon fill={COLOR_GREY_BLUE} stroke={COLOR_GREY_BLUE} />
      }
    }
  }
  switch (type) {
    case TEXT_TYPE:
      return <TextSvg stroke={COLOR_GREY_BLUE} />
    case CAROUSEL_TYPE:
      return <CarouselSvg fill={COLOR_GREY_BLUE} stroke={COLOR_GREY_BLUE} />
    case CARD_TYPE:
      return <RichCardSvg fill={COLOR_GREY_BLUE} stroke={COLOR_GREY_BLUE} />
    default:
      return null
  }
}

const RbmElementCard = ({
  name,
  type,
  onClick,
  onDelete,
  isButton = false,
  isSuggestion = false,
  hasEmailAction = false,
  actions = []
}) => {
  const getActionIcon = (action) => {
    switch (action) {
      case 'send-email':
        return '📧'
      case 'schedule-flow':
        return '📅'
      case 'webhook':
        return '🔗'
      default:
        return '⚡'
    }
  }
  const handleDeleteClick = (event) => {
    event.stopPropagation()
    onDelete()
  }

  return (
    <div
      onClick={onClick}
      className={`cursor-pointer relative group border-2 rounded-xl transition-all duration-200 ease-in-out hover:shadow-md hover:border-indigo-400 hover:-translate-y-0.5 ${
        hasEmailAction
          ? 'border-green-300 bg-green-50 hover:bg-green-50'
          : 'border-indigo-200 bg-indigo-50/50 hover:bg-indigo-50'
      } ${isButton || isSuggestion ? 'h-14 w-1/3' : 'h-20 w-1/3'} p-3 gap-2 flex justify-center items-center`}
    >
      <button
        onClick={(e) => handleDeleteClick(e)}
        className="absolute top-1.5 right-1.5 z-10 text-red-400 opacity-0 group-hover:opacity-100 hover:bg-red-500 hover:text-white rounded-md p-0.5 transition-all duration-200"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
      {(hasEmailAction || actions.length > 0) && (
        <div
          className="absolute top-1.5 left-1.5 flex gap-1"
          title={
            actions.length > 0
              ? `Actions: ${actions.join(', ')}`
              : 'Sends email on click'
          }
        >
          {hasEmailAction && <span className="text-xs">📧</span>}
          {actions.map((action) => (
            <span key={action} className="text-xs" title={action}>
              {getActionIcon(action)}
            </span>
          ))}
        </div>
      )}
      <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
        {getSvg(type, isButton || isSuggestion)}
      </div>
      <h2 className="text-sm font-medium text-gray-700 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center">
        {name}
      </h2>
    </div>
  )
}

export default RbmElementCard
